// Real build version, BAKED into the shipped JS bundle at deploy time.
//
// deploy-do.sh replaces the `__CP_BUILD_VERSION__` token in web-build/*.js with the
// RESET_VERSION it was invoked with. So this constant reflects the ACTUAL code the device
// is running — NOT the optimistic `localStorage.__app_reset` flag, which can lie: the old
// self-update wrote `__app_reset = latest` BEFORE the reload confirmed the new bundle
// actually loaded, so a stale reload (CDN/propagation lag) left the app REPORTING the new
// version while still RUNNING the old code. That is the "admin shows newest / driver is on
// an old build" bug. A baked constant can't lie — it changes only when the bundle changes.
//
// Reported to the backend as the driver's appVersion and used as the source of truth for
// the self-update comparison.
export const BUILD_VERSION = '__CP_BUILD_VERSION__';

// True only once the deploy has stamped a real version (dev/unstamped builds keep the token).
export const hasRealBuildVersion = (): boolean => /^v\d+$/.test(BUILD_VERSION);
